import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwitchAccountWidgetComponent } from './switch-account-widget.component';
import {
  P500UIButtonsModule,
  P500UIIconsModule,
  P500UIProgressModule,
  P500UITooltipModule
} from "@platform500services/p500-ui-kit";
import { FormsModule } from "@angular/forms";
import { SearchFilterModule } from "../../pipes/search-filter/search-filter.module";
import { SearchModule } from "../form-fields/search/search.module";

@NgModule({
  declarations: [
    SwitchAccountWidgetComponent
  ],
  imports: [
    CommonModule,
    P500UIButtonsModule,
    P500UIProgressModule,
    FormsModule,
    P500UIIconsModule,
    SearchFilterModule,
    SearchModule,
    P500UITooltipModule
  ],
  exports: [
    SwitchAccountWidgetComponent
  ]
})
export class SwitchAccountWidgetModule { }
